import { h } from 'preact'
import { useCallback } from 'preact/hooks'
import PropTypes from 'prop-types'

import { submitParentForm } from 'lib/DOMHelpers'

import './index.sass'

export default function Checkbox(props){
  if ('value' in props && !('checked' in props)){
    props = {...props, checked: props.value}
    delete props.value
  }

  const onChange = useCallback(
    event => {
      if (props.onChange) props.onChange(event.target.checked)
    },
    [props.onChange],
  )

  const onKeyDown = event => {
    if (event.code === 'Space'){
      event.preventDefault()
      if (props.onChange) props.onChange(!props.checked)
      return false
    }
    if (event.code === 'Enter'){
      event.preventDefault()
      submitParentForm(event.target)
      return false
    }
  }

  let className = 'Checkbox'

  return <label
    className={className}
    disabled={props.disabled}
    data-checked={!!props.checked}
    data-reverse={!!props.reverse}
    data-unsaved={!!props.unsaved}
  >
    <div
      className="Checkbox-pseudo-checkbox"
      tabIndex={props.disabled ? undefined : props.tabIndex}
      onKeyDown={onKeyDown}
    />
    <input
      type="checkbox"
      checked={!!props.checked}
      onChange={props.disabled ? undefined : onChange}
      disabled={props.disabled}
    />
    <span className="Checkbox-label">{props.label}</span>
  </label>
}

Checkbox.propTypes = {
  reverse: PropTypes.bool,
  disabled: PropTypes.bool,
  unsaved: PropTypes.bool,
  value: PropTypes.bool,
  checked: PropTypes.bool,
  label: PropTypes.node,
  onChange: PropTypes.func.isRequired,
  tabIndex: PropTypes.number,
}

Checkbox.defaultProps = {
  tabIndex: 0,
}

Checkbox.focus = checkbox => {
  if (checkbox.current) checkbox = checkbox.current
  if (checkbox.base) checkbox = checkbox.base
  checkbox.querySelector('.Checkbox-pseudo-checkbox').focus()
}
